import uikit from '../uikit';
import * as Backbone from 'backbone';
import {getLevel,levels,getLogger} from 'loglevel';

import * as Features from '../utilities/featureFlags';

import {attachBackboneViewDebugHelpers} from '../utilities/backboneDebugHelpers';
// Components
let Accordion = require('../components/Accordion/Accordion');
import {createAjaxLoader} from '../components/AjaxLoader/AjaxLoader';
import {createCsrImpersonationBar} from '../components/CsrImpersonationBar/CsrImpersonationBar';
import {create as BrightcoveVideoPlayer} from '../components/BrightcoveVideoPlayer/BrightcoveVideoPlayer';
let footer = require('../components/Footer/Footer');
import {create as createEllipsis} from '../components/Ellipsis/EllipsisView';
import {create as createCategoryZeroList} from '../components/CategoryZeroList/CategoryZeroListView';
import {create as createForm} from '../components/Form/Form';
import {create as createHeader} from '../components/Header/Header';
import {createArwPrmView} from '../components/ArwPrm/ArwPrmView';
import {create as createFamilyPagesNavigationTabs} from '../components/FamilyPagesNavigationTabs/FamilyPagesNavigationTabsView';
import {createMyCart} from '../components/MyCart/MyCart';
import {createOffices} from '../components/Offices/Offices';
import {create as ProductPricingLoader} from '../components/ProductPricing/ProductPricingLoader';
import {createProductMerchandiseList} from '../components/ProductMerchandiseList/ProductMerchandiseListView';
import { createSecondaryNavigation } from '../components/SecondaryNavigation/SecondaryNavigation';
import { createContactUsEmailForm } from '../components/ContactUsV2/ContactUsV2EmailView'

let HeroCarouselView = require('../components/Carousel/HeroCarouselView');
let ScrollableCarousel = require('../components/ScrollableCarousel/ScrollableCarouselView');
import { createManufacturerTabsView } from '../components/ManufacturerTabs/ManufacturerTabsView';
let RichRelevanceProductPlacement = require('../components/RichRelevance/RichRelevance-ProductPlacement');
import RichRelevance from '../components/RichRelevance/RichRelevance';
let ScrollTo = require('../components/ScrollTo/ScrollTo');
let ProfileInformationView = require('../components/ProfileInformation/ProfileInformationView');
let LoginView = require('../components/Login/LoginView');
let OrderDetailsView = require('../components/OrderDetails/OrderDetails');
let CustomHandlers = require('../components/CustomHandlers/CustomHandlers');
let LoginSplashView = require('../components/LoginSplash/LoginSplash');
let MyArrowView = require('../components/MyArrow/MyArrow');
import { create as createMegaMenu } from '../components/MegaMenu/MegamenuView';
import { create as createMegaMenuAjaxList } from '../components/MegaMenuAjaxList/MegaMenuAjaxListView';
let OrderHistoryView = require('../components/OrderHistory/OrderHistoryView');
let ResponsiveBackgroundImageView = require('../components/ResponsiveBackgroundImage/ResponsiveBackgroundImageView');
let Analytics = require('../components/Analytics/Analytics');
let CacheCookieHelper = require('../components/CacheCookieHelper/CacheCookieHelper');
const IFrameVideoPlayer = require('../components/IFrameVideoPlayer/IFrameVideoPlayer');
const ShareLink = require('../components/ShareLink/ShareLink');
const ReadMore = require('../components/ReadMore/ReadMore');

import {default as productImpressions, createProductImpressions} from '../components/ProductImpressions/ProductImpressions';
import {impressionsTracking, createImpressionsTracking } from '../components/ImpressionsTracking/ImpressionsTracking';
import {createMasonryGridView} from '../components/MasonryGridView/MasonryGridView';
import {createCmsModal} from '../components/CmsModal/CmsModal';
import {createCmsModalCta} from '../components/CmsModal/CmsModal';
import {createPerksNotificationBar} from '../components/PerksNotificationBar/PerksNotificationBar';
import {createBlockedUserNotificationBar} from '../components/BlockedUserNotificationBar/BlockedUserNotificationBar';
import {createBomModal} from '../components/BomModal/BomModal';
import {createProductDetailPdfDownload} from '../js/components/ProductDetailPdfDownload';
import {initializeMarketingTracking} from '../components/MarketingTracking/MarketingTracking';
import {createArticlesEventMarketingTracking} from '../components/MarketingTracking/ArticlesEventsMarketingTracking';
import {createTabs} from '../components/Tabs/Tabs';
import Registration from '../components/Registration/Registration';
import GetStarted from '../components/Registration/GetStarted'
import UserProfile from '../components/Registration/ProfileUpdateEUC'
import {createCurrencyWarningModal} from '../components/CurrencyWarningModal/CurrencyWarningModal';
import {createAdvancedSearchView} from '../components/Header/js/AdvancedSearchView';
import { createAdvancedSearchModalView } from '../components/Header/js/AdvancedSearchModalView';
let IdleActivityWatcher = require('../components/IdleActivityWatcher/IdleActivityWatcher');
let BloomreachWidget = require('../components/Bloomreach/BloomreachWidget');
import {createTieredPricingNotificationBar} from '../components/TieredPricingNotificationBar/TieredPricingNotificationBar';
import NewsletterBanner from '../components/Newsletters/NewsletterBanner.js';

// Needed to initialize analytics
var config = require('../js/config');

const log = getLogger('EntryPoints');

export class WWWEntryPoint extends uikit.EntryPoint {

  // Example constructor for specifying EntryPoint options
  constructor() {
    super();
    if (getLevel() <= levels.DEBUG) {
      attachBackboneViewDebugHelpers(Backbone);
    }
    //  this.initializeOnIds = ['searchContainer', 'contentSearchContainer'];
    //  this.featureFlag = ProductSearchShowTotalResultCount;
    //  this.featureFlagOff = true;
  }

  register() {
    log.debug('WWWEntryPoint:register()');
    RichRelevance.singleton();

    // Example component register options
    // showing defaults for defer and priority
    //
    //uikit.components.register(Accordion.create, {
    //  featureFlag: ProductSearchShowTotalResultCount,
    //  featureFlagOff: false,
    //  defer: true,
    //  priority: true,
    //  ajaxable: true,
    //  delayLoading: false (If this is enabled remove priority flag)
    //});

    // Priority components
    uikit.components.register(ProductPricingLoader, { defer: false });
    uikit.components.register(createForm);
    uikit.components.register(createMyCart, { ajaxable: Features.EnableAjaxLoadHeader.isEnabled() });
    uikit.components.register(createSecondaryNavigation, { ajaxable: false });
    uikit.components.register(HeroCarouselView.create);
    uikit.components.register(ScrollableCarousel.create);
    uikit.components.register(RichRelevanceProductPlacement.create);
    uikit.components.register(ProfileInformationView.create, { priority: true });
    uikit.components.register(OrderDetailsView.create);
    uikit.components.register(Registration.create);
    uikit.components.register(GetStarted.create);
    uikit.components.register(UserProfile.create);
    uikit.components.register(NewsletterBanner.create);
    uikit.components.register(LoginView.create);
    uikit.components.register(CustomHandlers.create);
    uikit.components.register(LoginSplashView.create);
    uikit.components.register(MyArrowView.create);
    uikit.components.register(OrderHistoryView.create);
    uikit.components.register(createCsrImpersonationBar, { priority: false, ajaxable: true });
    uikit.components.register(createAdvancedSearchModalView, { ajaxable: Features.EnableAjaxLoadHeader.isEnabled() });
    uikit.components.register(IdleActivityWatcher.create);

    // Non Priority components
    uikit.components.register(Accordion.create, { priority: false });
    uikit.components.register(createAjaxLoader, { priority: false, ajaxable: false });
    uikit.components.register(createEllipsis, { priority: false });
    uikit.components.register(ScrollTo.create, { priority: false });
    uikit.components.register(ResponsiveBackgroundImageView.create, { priority: false });
    uikit.components.register(IFrameVideoPlayer.create, { priority: false });
    uikit.components.register(ReadMore.create, { priority: false, ajaxable: false });
    uikit.components.register(BrightcoveVideoPlayer, { priority: false });

    uikit.components.register(createHeader, { priority: false, ajaxable: Features.EnableAjaxLoadHeader.isEnabled() });
    uikit.components.register(createMegaMenuAjaxList, { priority: false, ajaxable: Features.EnableAjaxLoadHeader.isEnabled() });
    uikit.components.register(createMegaMenu, { priority: false, ajaxable: Features.EnableAjaxLoadHeader.isEnabled() });

    uikit.components.register(createOffices, { priority: false, ajaxable: false });
    uikit.components.register(createCategoryZeroList, { priority: false, ajaxable: true });
    uikit.components.register(createArwPrmView, { priority: false, ajaxable: false });
    uikit.components.register(createFamilyPagesNavigationTabs, { priority: false, ajaxable: false });
    uikit.components.register(createProductImpressions, { priority: false, ajaxable: true });
    uikit.components.register(createImpressionsTracking, { priority: false, ajaxable: true });
    uikit.components.register(createManufacturerTabsView, { priority: false });
    uikit.components.register(createProductMerchandiseList, { priority: false, ajaxable: true });
    uikit.components.register(createPerksNotificationBar, { priority: false, ajaxable: Features.EnableAjaxLoadHeader.isEnabled() });
    uikit.components.register(createBlockedUserNotificationBar, { priority: false, ajaxable: Features.EnableAjaxLoadHeader.isEnabled() });
    uikit.components.register(createArticlesEventMarketingTracking, { priority: false, ajaxable: true });
    uikit.components.register(createBomModal, { priority: false, ajaxable: true });
    uikit.components.register(createTabs, { priority: false, ajaxable: false });
    uikit.components.register(createContactUsEmailForm, { priority: false, ajaxable: false });
    uikit.components.register(BloomreachWidget.create, { priority: false, ajaxable: true, featureFlag: Features.DeferLoadBloomreachImages });
    uikit.components.register(createTieredPricingNotificationBar, { priority: false });
    uikit.components.register(createProductDetailPdfDownload, { priority: false });

    // Delay loading ajax components
    uikit.components.register(createMasonryGridView, { ajaxable: true, delayLoading: true });
    uikit.components.register(createCmsModal, { priority: false, ajaxable: false, delayLoading: true });
    uikit.components.register(createCmsModalCta, { priority: false, ajaxable: true, delayLoading: true });

    _.defer(() => {
      if (!Features.AjaxLoadPageFooter.isEnabled()) {
        uikit.components.register(footer.create, { priority: false, ajaxable: false });
      }
      uikit.components.register(ShareLink.create, { priority: false });
      uikit.components.register(createCurrencyWarningModal, { priority: false, ajaxable: false });
    });
  }

  initialize() {
    log.debug('WWWEntryPoint:initialize()');
    Analytics.initialize(config);
    if (Features.EnableFECacheCookie.isEnabled()) {
      CacheCookieHelper.initialize();
    }
    productImpressions.initialize();
    impressionsTracking.initialize();
  }
}



// WEBPACK FOOTER //
// ./assets/entryPoints/WWWEntryPoint.js